module.exports = __webpack_public_path__ + "static/media/phone.fc88f16f.svg";